module.exports = __webpack_public_path__ + "img/round-arrow-right-light-blue.acd799f6.svg";